// src/index.tsx
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';

// Clean up any existing content
const rootElement = document.getElementById('root');
if (rootElement?.hasChildNodes()) {
  const newRootElement = document.createElement('div');
  newRootElement.id = 'root';
  document.body.replaceChild(newRootElement, rootElement);
}

const root = createRoot(document.getElementById('root')!);

root.render(
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>
);

serviceWorker.unregister();

